export const module_config = {
    // BusinessIncomeTable
    BUSINESS_INCOME_TABLE: {
        name: '商务收入',
        defaultColumns: [
            {
                "title": "订单编号",
                "value": "order_no",
                "width": 140,
                "header_align": "center",
                "align": "center",
                "sortable": "custom",
                "field": "order_no",

            },
            {
                "title": "客户名称",
                "value": "customer_name",
                "width": 120,
                "slot": true,
                "header_align": "center",
                "align": "center",
                "sortable": "custom",
                "field": "customer_id",

            },
            {
                "title": "是否有效",
                "value": "bool_covenant_alias",
                "width": 120,
                "header_align": "center",
                "align": "center",
                "sortable": "custom",
                "field": "bool_covenant",
                "hide": true,
            },
            {
                "title": "订单ID",
                "value": "id",
                "width": 120,
                "header_align": "center",
                "align": "center",
                "sortable": "custom",
                "field": "id",
                "hide": true,
            },
            {
                "title": "父订单ID",
                "value": "pid",
                "width": 120,
                "header_align": "center",
                "align": "center",
                "sortable": "custom",
                "field": "pid",
                "hide": true,

            },
            {
                "title": "订单类型",
                "value": "order_type_alias",
                "width": 120,
                "header_align": "center",
                "align": "center",
                "sortable": "custom",
                "field": "order_type",
            },
            {
                "title": "客户性质",
                "value": "customer_nature",
                "width": 120,
                "header_align": "center",
                "align": "center",
                "sortable": false,
                "field": "customer_nature",

            },
            {
                "title": "是否年框",
                "value": "year_frame_alias",
                "width": 120,
                "header_align": "center",
                "align": "center",
                "sortable": false,
                "field": "year_frame_alias",

            },
            {
                "title": "乙方名称",
                "value": "company_name",
                "width": 110,
                "header_align": "center",
                "align": "center",
                "sortable": "custom",
                "field": "company_id",

            },
            {
                "title": "订单来源",
                "value": "order_source",
                "width": 120,
                "header_align": "center",
                "align": "center",
                "sortable": "custom",
                "field": "order_source",

            },
            {
                "title": "品牌",
                "value": "brand",
                "width": 100,
                "header_align": "center",
                "align": "center",
                "sortable": false,
                "field": "brand",

            },
            {
                "title": "品牌集团",
                "value": "combine_brand_name",
                "width": 110,
                "header_align": "center",
                "align": "center",
                "hide": true,
                "sortable": "custom",
                "field": "combine_brand_name",

            },
            {
                "title": "产品/内容",
                "value": "product",
                "width": 120,
                "header_align": "center",
                "align": "center",
                "sortable": false,
                "field": "product",

            },
            {
                "title": "行业",
                "value": "trade",
                "width": 120,
                "header_align": "center",
                "align": "center",
                "sortable": "custom",
                "field": "trade",

            },
            {
                "title": "客单",
                "value": "passenger_order_interval",
                "width": 120,
                "header_align": "center",
                "align": "center",
                "sortable": "custom",
                "field": "passenger_order_interval",

            },
            {
                "title": "品类",
                "value": "product_category",
                "width": 120,
                "header_align": "center",
                "align": "center",
                "sortable": "custom",
                "field": "product_category",

            },
            {
                "title": "合作形式",
                "value": "form_of_cooperation",
                "width": 120,
                "header_align": "center",
                "align": "center",
                "sortable": "custom",
                "field": "form_of_cooperation",

            },
            {
                "title": "项目名称",
                "value": "project_name",
                "width": 120,
                "hide": true,
                "header_align": "center",
                "align": "center",
                "sortable": "custom",
                "field": "project_name",
            },
            {
                "title": "策略人",
                "value": "strategy_name",
                "width": 120,
                "header_align": "center",
                "align": "center",
                "hide": true,
                "sortable": false,
                "field": "strategy_name",
            },
            {
                "title": "策划人",
                "value": "planner_name",
                "width": 120,
                "header_align": "center",
                "align": "center",
                "sortable": false,
                "field": "planner_name",
                "hide":true
            },
            {
                "title": "媒介人",
                "value": "medium_name",
                "width": 120,
                "header_align": "center",
                "align": "center",
                "slot": true,
                "sortable": false,
                "field": "medium_name",
                "custom": "link_user",
                "link_user_id_column": "medium_id",
                "hide":true
            },
            {
                "title": "要求发布时间",
                "value": "release_timestamp_alias",
                "width": 140,
                "header_align": "center",
                "align": "center",
                "sortable": "custom",
                "field": "release_timestamp",
                "hide": true,

            },
            {
                "title": "红人名称",
                "value": "artist_nickname",
                "width": 110,
                "header_align": "center",
                "align": "center",
                "sortable": "custom",
                "field": "artist_id",
                "hide": false,
            },
            {
                "title": "经纪人",
                "value": "agent_name",
                "width": 100,
                "header_align": "center",
                "align": "center",
                "sortable": "custom",
                "field": "artist_id",
                "hide": false,
            },
            {
                "title": "分成比例",
                "value": "exec_rate",
                "width": 80,
                "header_align": "center",
                "align": "right",
                "sortable": "custom",
                "field": "rate",
                "hide": true,
            },
            {
                "title": "红人分红",
                "value": "exec_artist_income",
                "width": 120,
                "header_align": "center",
                "align": "right",
                "sortable": "custom",
                "field": "artist_income",
                "hide": true,
            },
            {
                "title": "公司收入",
                "value": "exec_company_income",
                "width": 120,
                "header_align": "center",
                "align": "right",
                "sortable": "custom",
                "field": "company_income",
                "hide": true,
            },
            {
                "title": "含税收入",
                "value": "payment_account",
                "width": 110,
                "header_align": "center",
                "align": "right",
                "sortable": "custom",
                "field": "payment_account",

            },
            {
                "title": "下单金额",
                "value": "place_order_money",
                "width": 110,
                "header_align": "center",
                "align": "right",
                "sortable": "custom",
                "field": "place_order_money",
                "hide":true

            },
            {
                "title": "标记开票",
                "value": "is_mark_invoiced_alias",
                "width": 110,
                "header_align": "center",
                "align": "center",
                "sortable": "custom",
                "field": "is_mark_invoiced",
                "hide": true,
            },
            {
                "title": "标记开票时间",
                "value": "mark_invoiced_time",
                "width": 130,
                "header_align": "center",
                "align": "center",
                "sortable": "custom",
                "field": "mark_invoiced_time",
                "hide": true,
            },
            {
                "title": "标记返点",
                "value": "is_mark_rebate_alias",
                "width": 110,
                "header_align": "center",
                "align": "center",
                "sortable": "custom",
                "field": "is_mark_invoiced",
                "hide": true,

            },
            {
                "title": "标记返点时间",
                "value": "mark_rebate_time",
                "width": 130,
                "header_align": "center",
                "align": "center",
                "sortable": "custom",
                "field": "mark_invoiced_time",
                "hide": true,
            },
            {
                "title": "发票状态",
                "value": "invoice_status_alias",
                "width": 110,
                "header_align": "center",
                "align": "center",
                "sortable": "custom",
                "field": "invoice_status",
                "hide": true,
            },
            {
                "title": "能否开票",
                "value": "is_can_invoice_alias",
                "width": 110,
                "header_align": "center",
                "align": "center",
                "sortable": "custom",
                "field": "is_can_invoice",
                "hide": true,
            },
            {
                "title": "已开票金额",
                "value": "invoice_money_done",
                "width": 120,
                "header_align": "center",
                "align": "right",
                "sortable": false,
                "field": "invoice_money_done",
                "hide": true,
            },
            {
                "title": "申请中开票金额",
                "value": "invoice_money_occupy",
                "width": 120,
                "header_align": "center",
                "align": "right",
                "sortable": false,
                "field": "invoice_money_occupy",
                "hide": true,
            }, {
                "title": "开票时间",
                "value": "invoice_time",
                "width": 110,
                "header_align": "center",
                "align": "center",
                "sortable": "custom",
                "field": "invoice_time",
                "hide": true,
            }, {
                "title": "发票开完",
                "value": "is_done_invoice_alias",
                "width": 110,
                "header_align": "center",
                "align": "center",
                "sortable": "custom",
                "field": "is_done_invoice",
                "hide": true,
            }, {
                "title": "销售",
                "value": "sale_name",
                "width": 100,
                "header_align": "center",
                "align": "center",
                "sortable": "custom",
                "field": "sale_id",
                "custom": "link_user",
                "link_user_id_column": "sale_id"
            }, {
                "title": "销售小组",
                "value": "organization_name",
                "width": 110,
                "header_align": "center",
                "align": "center",
                "sortable": "custom",
                "field": "organization_name",

            }, {
                "title": "下单时间",
                "value": "created_timestamp_alias",
                "width": 110,
                "header_align": "center",
                "align": "center",
                "sortable": "custom",
                "field": "created_timestamp",

            }, {
                "title": "执行",
                "value": "executor_name",
                "width": 100,
                "header_align": "center",
                "align": "center",
                "sortable": false,
                "field": "executor_name",
                "custom": "link_user",
                "hide": true,
                "link_user_id_column": "executor_id"
            }, {
                "title": "招商",
                "value": "commerce_name",
                "width": 100,
                "header_align": "center",
                "align": "center",
                "hide": true,
                "sortable": false,
                "field": "commerce_name",

            }, {
                "title": "执行时间",
                "value": "exec_at",
                "width": 110,
                "header_align": "center",
                "align": "center",
                "sortable": "custom",
                "field": "exec_timestamp",
                "hide": true,

            }, {
                "title": "回款金额",
                "value": "sum_amount",
                "width": 120,
                "header_align": "center",
                "align": "right",
                "sortable": false,
                "field": "sum_amount",
                "hide": true,

            }, {
                "title": "应收款",
                "value": "remain_account",
                "width": 120,
                "header_align": "center",
                "align": "right",
                "sortable": false,
                "field": "remain_account",
                "hide": true,
            }, {
                "title": "代下单平台费",
                "value": "platform_fee_po",
                "width": 120,
                "header_align": "center",
                "align": "right",
                "sortable": false,
                "field": "platform_fee_po",
                "hide": true,

            }, {
                "title": "广告收入",
                "value": "adv_revenue",
                "width": 120,
                "header_align": "center",
                "align": "right",
                "sortable": false,
                "field": "adv_revenue",
                "hide": true,

            }, {
                "title": "税点",
                "value": "tax_point",
                "width": 100,
                "header_align": "center",
                "align": "right",
                "sortable": "custom",
                "field": "tax_point",
                "hide": true,

            }, {
                "title": "是否含税",
                "value": "bool_tax_alias",
                "width": 120,
                "header_align": "center",
                "align": "center",
                "sortable": "custom",
                "field": "bool_tax",
                "hide": true,

            }, {
                "title": "粉丝福利",
                "value": "weal_price",
                "width": 120,
                "header_align": "center",
                "align": "right",
                "sortable": false,
                "field": "weal_price",
                "hide": true,
            }, {
                "title": "投流费",
                "value": "invest_flow_fee",
                "width": 120,
                "header_align": "center",
                "align": "right",
                "sortable": false,
                "field": "invest_flow_fee",
                "hide": true,

            }, {
                "title": "微任务所得",
                "value": "micro_task_income",
                "width": 120,
                "header_align": "center",
                "align": "right",
                "sortable": false,
                "field": "micro_task_income",
                "hide": true,

            }, {
                "title": "微任务价",
                "value": "micro_task_price",
                "width": 120,
                "header_align": "center",
                "align": "right",
                "sortable": false,
                "field": "micro_task_price",
                "hide": true,

            }, {
                "title": "执行价",
                "value": "exec_price",
                "width": 120,
                "header_align": "center",
                "align": "right",
                "sortable": false,
                "field": "exec_price",
                "hide": true,

            }, {
                "title": "授权价",
                "value": "authorized_price",
                "width": 120,
                "header_align": "center",
                "align": "right",
                "sortable": false,
                "field": "authorized_price",
                "hide": true,

            }, {
                "title": "购物车收费",
                "value": "cart_charges",
                "width": 120,
                "header_align": "center",
                "align": "right",
                "sortable": false,
                "field": "cart_charges",
                "hide": true,

            }, {
                "title": "坑位费",
                "value": "cart_commission",
                "width": 120,
                "header_align": "center",
                "align": "right",
                "sortable": false,
                "hide": true,
                "field": "cart_commission",

            }, {
                "title": "其他费",
                "value": "other_fee",
                "width": 120,
                "header_align": "center",
                "align": "right",
                "sortable": false,
                "field": "other_fee",
                "hide": true,

            }, {
                "title": "返点金额",
                "value": "rebates_amount",
                "width": 120,
                "header_align": "center",
                "align": "right",
                "sortable": false,
                "field": "rebates_amount",
                "hide": true,

            }, {
                "title": "返点比例",
                "value": "rebates_rate",
                "width": 110,
                "header_align": "center",
                "align": "right",
                "sortable": "custom",
                "field": "rebates_rate",
                "hide": true,

            }, {
                "title": "是否挂车",
                "value": "is_trailer_alias",
                "width": 120,
                "header_align": "center",
                "align": "center",
                "sortable": "custom",
                "field": "is_trailer",
                "hide": true,

            }, {
                "title": "挂车佣金(%)",
                "value": "commission_trailer",
                "width": 120,
                "header_align": "center",
                "align": "right",
                "sortable": false,
                "field": "commission_trailer",
                "hide": true
            }, {
                "title": "是否直播",
                "value": "is_lb_alias",
                "width": 120,
                "header_align": "center",
                "align": "center",
                "sortable": "custom",
                "field": "is_lb",
                "hide": true,

            }, {
                "title": "是否保量",
                "value": "is_quantity_alias",
                "width": 120,
                "header_align": "center",
                "align": "center",
                "sortable": "custom",
                "field": "is_quantity",
                "hide": true,

            }, {
                "title": "直播佣金(%)",
                "value": "commission_rate",
                "width": 120,
                "header_align": "center",
                "align": "right",
                "sortable": false,
                "field": "commission_rate",
                "hide": true,

            }, {
                "title": "平台",
                "value": "platforms",
                "width": 120,
                "header_align": "center",
                "align": "left",
                "sortable": false,
                "field": "platforms",

            }, {
                "title": "内容(发布)形式",
                "value": "content_forms",
                "width": 120,
                "header_align": "center",
                "align": "left",
                "sortable": false,
                "field": "content_forms",

            }, {
                "title": "坑位",
                "value": "ad_space",
                "width": 120,
                "header_align": "center",
                "align": "center",
                "hide": true,
                "sortable": "custom",
                "field": "ad_space_id",

            }, {
                "title": "发布链接",
                "value": "publish_link",
                "width": 120,
                "header_align": "center",
                "align": "left",
                "sortable": false,
                "field": "publish_link",
                "hide": true,

            }, {
                "title": "是否执行",
                "value": "bool_exec_alias",
                "width": 110,
                "header_align": "center",
                "align": "center",
                "sortable": "custom",
                "field": "bool_exec",
                "hide": true,

            }, {
                "title": "回款状态",
                "value": "pay_status_alias",
                "width": 110,
                "header_align": "center",
                "align": "center",
                "sortable": "custom",
                "field": "pay_status",
                "hide": true,

            }, {
                "title": "结款方式",
                "value": "pay_method_alias",
                "width": 110,
                "header_align": "center",
                "align": "center",
                "sortable": "custom",
                "field": "pay_method",
                "hide": true,

            }, {
                "title": "结款时间",
                "value": "payed_timestamp_alias",
                "width": 110,
                "header_align": "center",
                "align": "center",
                "hide": true,
                "sortable": "custom",
                "field": "payed_timestamp",
            }, {
                "title": "备注",
                "value": "remark",
                "width": 200,
                "header_align": "center",
                "align": "center",
                "sortable": false,
                "hide": true,
                "field": "remark",
            }, {
                "title": "收款形式",
                "value": "payment_method_alias",
                "width": 110,
                "header_align": "center",
                "align": "center",
                "sortable": "custom",
                "hide": true,
                "field": "contract_filed",

            }, {
                "title": "合同归档",
                "value": "contract_filed_alias",
                "width": 110,
                "header_align": "center",
                "align": "center",
                "sortable": "custom",
                "field": "contract_filed",
                "hide": true,

            }, {
                "title": "合同编号",
                "value": "contract_no",
                "width": 120,
                "header_align": "center",
                "align": "center",
                "sortable": false,
                "field": "contract_no",
                "hide": true,

            }, {
                "title": "合同金额",
                "value": "contract_amount",
                "width": 120,
                "hide": true,
                "header_align": "center",
                "align": "right",
                "sortable": false,
                "field": "contract_amount",

            }, {
                "title": "财务备注",
                "value": "f_remark",
                "width": 120,
                "hide": true,
                "header_align": "center",
                "align": "left",
                "sortable": false,
                "field": "f_remark",

            }, {
                "title": "发票号码",
                "value": "invoice_number",
                "width": 120,
                "hide": true,
                "header_align": "center",
                "align": "center",
                "sortable": false,
                "field": "invoice_number",

            }, {
                "title": "项目利润金额",
                "value": "money_achievement",
                "width": 150,
                "header_align": "center",
                "align": "right",
                "hide": true,
                "sortable": false,
                "field": "money_achievement",

            }, {
                "title": "建单人",
                "value": "creator_name",
                "width": 110,
                "header_align": "center",
                "align": "center",
                "sortable": "custom",
                "field": "creator_id",
                "hide": true,
            }, {
                "title": "老客激活",
                "value": "activation_type_alias",
                "width": 110,
                "header_align": "center",
                "align": "center",
                "sortable": "custom",
                "field": "activation_type",
                "hide": true,

            }, {
                "title": "平台订单编号",
                "value": "oth_order_no",
                "width": 150,
                "header_align": "center",
                "align": "center",
                "sortable": "custom",
                "field": "oth_order_no",
                "hide": true,

            }, {
                "title": "创建时间",
                "value": "created_at",
                "width": 110,
                "header_align": "center",
                "align": "center",
                "sortable": "custom",
                "field": "created_at",
                "hide": false,

            }, {
                "title": "修改时间",
                "value": "updated_at",
                "width": 110,
                "header_align": "center",
                "align": "center",
                "sortable": "custom",
                "field": "updated_at",
                "hide": false,

            }]
    }
}
